import { render, staticRenderFns } from "./singleSupplier.vue?vue&type=template&id=196b2b00&scoped=true&"
import script from "./singleSupplier.vue?vue&type=script&lang=js&"
export * from "./singleSupplier.vue?vue&type=script&lang=js&"
import style0 from "./singleSupplier.vue?vue&type=style&index=0&id=196b2b00&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "196b2b00",
  null
  
)

export default component.exports